@if (!customHandler) {
  <div [ngClass]="resizerClass"
    >
  </div>
}
<ng-content />
